export function Skeleton({ kind, height }: { kind: 'kpi' | 'chart' | 'table' | 'text'; height?: number }) {
  const h = height ?? { kpi: 108, chart: 280, table: 320, text: 16 }[kind];
  return <div className="skel" style={{ height: h }} aria-hidden="true" />;
}

/** Page-level loading layout: a KPI row and two chart blocks. */
export function PageSkeleton() {
  return (
    <div aria-busy="true" aria-label="Loading">
      <div className="grid">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="span-3">
            <Skeleton kind="kpi" />
          </div>
        ))}
      </div>
      <div className="grid">
        <div className="span-8">
          <Skeleton kind="chart" />
        </div>
        <div className="span-4">
          <Skeleton kind="chart" />
        </div>
      </div>
      <Skeleton kind="table" />
    </div>
  );
}
